import { styled } from 'styletron-react';
import { rhythm } from '../../utils/typography';

export const TeaserContainer = styled('div', {
  marginBottom: rhythm(3 / 2),
});
